import { render, staticRenderFns } from "./TakeoutSetting.vue?vue&type=template&id=13d7f5cb&scoped=true"
import script from "./TakeoutSetting.vue?vue&type=script&lang=js"
export * from "./TakeoutSetting.vue?vue&type=script&lang=js"
import style0 from "./TakeoutSetting.vue?vue&type=style&index=0&id=13d7f5cb&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d7f5cb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13d7f5cb')) {
      api.createRecord('13d7f5cb', component.options)
    } else {
      api.reload('13d7f5cb', component.options)
    }
    module.hot.accept("./TakeoutSetting.vue?vue&type=template&id=13d7f5cb&scoped=true", function () {
      api.rerender('13d7f5cb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/plugin/dining/store/TakeoutSetting.vue"
export default component.exports